export default function abs(x: bigint) {
  return x < 0n ? -x : x
}
